<template>
    <div class="row justify-content-center">
        <div class="col-lg-8 col-xl-6">
            <StepsPercentage percentage="width:5%;" outerClass="mb-4" />

            <div class="card bg-white">
                <div class="card-body border-0">
                    <div class="chat-help d-flex align-items-center mb-4">
                        <div class="chat-help-avatar">
                            <img src="/images/chat-help-image.jpg" class="rounded-circle">
                        </div>
                        <div class="chat-help-bubble ml-3">
                            <div class="d-block d-lg-none">
                                Hi {{formData.firstName || 'there'}}, I’m Shane. I’m here to help you find your loan.
                            </div>
                            <div class="d-none d-lg-block">
                                Hi {{formData.firstName || 'there'}}, I’m Shane. I’m here to help you find your loan. Let me know how much you're looking to borrow and we'll get started with your application
                            </div>

                        </div>
                    </div>
        
                    <form @submit.prevent="validateBeforeSubmit">

                        <LoanSelect
                            label="How much do you want to borrow?"
                            id="loan_amount"
                            name="loan_amount"
                            type="hidden"
                            v-model="loan_amount"
                            v-validate="'required'"
                            errormsg="This is a required field"
                            :error="errors.first('loan_amount')" />
                    </form>
                </div><!--End Card Body-->
            </div><!--End Card-->
        </div><!--End Col-->
    </div><!--End Row-->
</template>

<script>
import axios from 'axios';
import StepsPercentage from '@/components/form/StepsPercentage.vue';
import LoanSelect from '@/components/form/LoanSelect.vue';
import { mapGetters, mapActions } from "vuex";

export default {
    name: 'WizardStep1',
    title: 'SMTFunds - As Heard on the Radio',
    components:{
        StepsPercentage,
        LoanSelect
    },

    methods: {
		...mapActions(['saveFormData']),
		validateBeforeSubmit() {
			this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.saveFormData({
						'firstStep': true,
                        'loan_amount' : this.loan_amount,
                        'loan_amount_raw' : this.loan_amount_raw,
                        'loan_amount_range' : this.loan_amount_range
					});
					this.$router.push({ path: '/apply/2' });
          		return;
				}
      		});
		},
        getLoanAmountValue(){
            const amounts = this.loanAmounts.find(o => o.type === process.env.VUE_APP_SITE_TYPE);
            const loanAmount = amounts.amounts.find(obj => {
                return obj.label === this.loan_amount;
            });
            this.loan_amount_raw = loanAmount.value;
            this.loan_amount_range = loanAmount.range;
            if(this.loan_amount !== ''){
                this.saveFormData({
                    'firstStep': true,
                    'loan_amount' : this.loan_amount,
                    'loan_amount_raw' : this.loan_amount_raw,
                    'loan_amount_range' : this.loan_amount_range,
                });
                this.$router.push({ path: '/apply/2' });
            }
            
        }
    },
	data() {
		return {
			validationAttempt: false,
            loan_amount: '',
            loan_amount_raw: 0,
            loan_amount_range: '',
            loading: false,
            chatLoading: true,
		}
    },
    computed: mapGetters(["loanAmounts", "formData"]),
    watch: {
        loan_amount: 'getLoanAmountValue'
    },
    created(){
        //this.loan_amount = this.formData.loan_amount || '';
        setTimeout(() => {
            this.chatLoading = false;
        }, 2000);
  }
}
</script>

<style>
    
</style>
